import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { useMemo, useEffect } from "react";
import { useResolvedStylesApi } from "./auth-service-tools195.js";
import { useProps } from "./auth-service-tools225.js";
import { factory } from "./auth-service-tools248.js";
import { getParsedComboboxData } from "./auth-service-tools327.js";
import { getOptionsLockup } from "./auth-service-tools328.js";
import { Combobox } from "./auth-service-tools331.js";
import { OptionsDropdown } from "./auth-service-tools348.js";
import { useCombobox } from "./auth-service-tools346.js";
import { InputBase } from "./auth-service-tools309.js";
import { useId } from "./auth-service-tools271.js";
import { useUncontrolled } from "./auth-service-tools323.js";
import { usePrevious } from "./auth-service-tools406.js";
const defaultProps = {
  searchable: false,
  withCheckIcon: true,
  allowDeselect: true,
  checkIconPosition: "left"
};
const Select = factory((_props, ref) => {
  const props = useProps("Select", defaultProps, _props);
  const {
    classNames,
    styles,
    unstyled,
    vars,
    dropdownOpened,
    defaultDropdownOpened,
    onDropdownClose,
    onDropdownOpen,
    onFocus,
    onBlur,
    onClick,
    onChange,
    data,
    value,
    defaultValue,
    selectFirstOptionOnChange,
    onOptionSubmit,
    comboboxProps,
    readOnly,
    disabled,
    filter,
    limit,
    withScrollArea,
    maxDropdownHeight,
    size,
    searchable,
    rightSection,
    checkIconPosition,
    withCheckIcon,
    nothingFoundMessage,
    name,
    form,
    searchValue,
    defaultSearchValue,
    onSearchChange,
    allowDeselect,
    error,
    rightSectionPointerEvents,
    id,
    clearable,
    clearButtonProps,
    hiddenInputProps,
    renderOption,
    onClear,
    autoComplete,
    scrollAreaProps,
    ...others
  } = props;
  const parsedData = useMemo(() => getParsedComboboxData(data), [data]);
  const optionsLockup = useMemo(() => getOptionsLockup(parsedData), [parsedData]);

  const _id = useId(id);

  const [_value, setValue, controlled] = useUncontrolled({
    value,
    defaultValue,
    finalValue: null,
    onChange
  });
  const selectedOption = typeof _value === "string" ? optionsLockup[_value] : void 0;
  const previousSelectedOption = usePrevious(selectedOption);
  const [search, setSearch] = useUncontrolled({
    value: searchValue,
    defaultValue: defaultSearchValue,
    finalValue: selectedOption ? selectedOption.label : "",
    onChange: onSearchChange
  });
  const combobox = useCombobox({
    opened: dropdownOpened,
    defaultOpened: defaultDropdownOpened,
    onDropdownOpen: () => {
      onDropdownOpen == null ? void 0 : onDropdownOpen();
      combobox.updateSelectedOptionIndex("active", {
        scrollIntoView: true
      });
    },
    onDropdownClose: () => {
      onDropdownClose == null ? void 0 : onDropdownClose();
      combobox.resetSelectedOption();
    }
  });
  const {
    resolvedClassNames,
    resolvedStyles
  } = useResolvedStylesApi({
    props,
    styles,
    classNames
  });
  useEffect(() => {
    if (selectFirstOptionOnChange) {
      combobox.selectFirstOption();
    }
  }, [selectFirstOptionOnChange, _value]);
  useEffect(() => {
    if (value === null) {
      setSearch("");
    }

    if (typeof value === "string" && selectedOption && ((previousSelectedOption == null ? void 0 : previousSelectedOption.value) !== selectedOption.value || (previousSelectedOption == null ? void 0 : previousSelectedOption.label) !== selectedOption.label)) {
      setSearch(selectedOption.label);
    }
  }, [value, selectedOption]);
  const clearButton = clearable && !!_value && !disabled && !readOnly && /* @__PURE__ */jsxRuntimeExports.jsx(Combobox.ClearButton, {
    size,
    ...clearButtonProps,
    onClear: () => {
      setValue(null, null);
      setSearch("");
      onClear == null ? void 0 : onClear();
    }
  });
  return /* @__PURE__ */jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
    children: [/* @__PURE__ */jsxRuntimeExports.jsxs(Combobox, {
      store: combobox,
      __staticSelector: "Select",
      classNames: resolvedClassNames,
      styles: resolvedStyles,
      unstyled,
      readOnly,
      onOptionSubmit: val => {
        onOptionSubmit == null ? void 0 : onOptionSubmit(val);
        const optionLockup = allowDeselect ? optionsLockup[val].value === _value ? null : optionsLockup[val] : optionsLockup[val];
        const nextValue = optionLockup ? optionLockup.value : null;
        nextValue !== _value && setValue(nextValue, optionLockup);
        !controlled && setSearch(typeof nextValue === "string" ? (optionLockup == null ? void 0 : optionLockup.label) || "" : "");
        combobox.closeDropdown();
      },
      size,
      ...comboboxProps,
      children: [/* @__PURE__ */jsxRuntimeExports.jsx(Combobox.Target, {
        targetType: searchable ? "input" : "button",
        autoComplete,
        children: /* @__PURE__ */jsxRuntimeExports.jsx(InputBase, {
          id: _id,
          ref,
          rightSection: rightSection || clearButton || /* @__PURE__ */jsxRuntimeExports.jsx(Combobox.Chevron, {
            size,
            error,
            unstyled
          }),
          rightSectionPointerEvents: rightSectionPointerEvents || (clearButton ? "all" : "none"),
          ...others,
          size,
          __staticSelector: "Select",
          disabled,
          readOnly: readOnly || !searchable,
          value: search,
          onChange: event => {
            setSearch(event.currentTarget.value);
            combobox.openDropdown();
            selectFirstOptionOnChange && combobox.selectFirstOption();
          },
          onFocus: event => {
            searchable && combobox.openDropdown();
            onFocus == null ? void 0 : onFocus(event);
          },
          onBlur: event => {
            var _a;

            searchable && combobox.closeDropdown();
            setSearch(_value != null ? ((_a = optionsLockup[_value]) == null ? void 0 : _a.label) || "" : "");
            onBlur == null ? void 0 : onBlur(event);
          },
          onClick: event => {
            searchable ? combobox.openDropdown() : combobox.toggleDropdown();
            onClick == null ? void 0 : onClick(event);
          },
          classNames: resolvedClassNames,
          styles: resolvedStyles,
          unstyled,
          pointer: !searchable,
          error
        })
      }), /* @__PURE__ */jsxRuntimeExports.jsx(OptionsDropdown, {
        data: parsedData,
        hidden: readOnly || disabled,
        filter,
        search,
        limit,
        hiddenWhenEmpty: !nothingFoundMessage,
        withScrollArea,
        maxDropdownHeight,
        filterOptions: searchable && (selectedOption == null ? void 0 : selectedOption.label) !== search,
        value: _value,
        checkIconPosition,
        withCheckIcon,
        nothingFoundMessage,
        unstyled,
        labelId: others.label ? `${_id}-label` : void 0,
        "aria-label": others.label ? void 0 : others["aria-label"],
        renderOption,
        scrollAreaProps
      })]
    }), /* @__PURE__ */jsxRuntimeExports.jsx(Combobox.HiddenInput, {
      value: _value,
      name,
      form,
      disabled,
      ...hiddenInputProps
    })]
  });
});
Select.classes = { ...InputBase.classes,
  ...Combobox.classes
};
Select.displayName = "@mantine/core/Select";
export { Select };